<template>
	<div v-bind="$attrs" class="tabs__body" :class="classList" >
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		classList: {
			type: [Object, Array],
			default: () => ([])
		}
	}
};
</script>


